import React from "react";
import { ILinkData } from "../data";

interface ILinkC {
  item: ILinkData;
  index: number;
}

const LinkC: React.FC<ILinkC> = ({ item, index }) => {
  const handleLink = () => {
    if (item.text === "LinkedIn") {
      window.open("https://www.linkedin.com/in/andrea-montrone-711a96180");
    } else {
      return "#";
    }
  }
  return (
    <div className="link" key={index} onClick={handleLink}>
      <div className="logo">
        <img src={item.link} alt="slack" />
      </div>
      <div className="link-title">
        <p>{item.text}</p>
        <h2> {item.text === "LinkedIn" ? "Ganiyu(Click to Show)" :item.address}</h2>
      </div>
    </div>
  )
}

export default LinkC;